namespace TabAurous.OMS {
    export namespace LabourMasterService {
        export const baseUrl = 'OMS/LabourMaster';

        export declare function Create(request: Serenity.SaveRequest<LabourMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LabourMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LabourMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LabourMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function FilterList(request: LaborRateRequest, onSuccess?: (response: Serenity.ListResponse<LabourMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLaborRate(request: LaborRateRequest, onSuccess?: (response: Serenity.ListResponse<Common.LaborRateResponse>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/LabourMaster/Create",
            Update = "OMS/LabourMaster/Update",
            Delete = "OMS/LabourMaster/Delete",
            Retrieve = "OMS/LabourMaster/Retrieve",
            List = "OMS/LabourMaster/List",
            FilterList = "OMS/LabourMaster/FilterList",
            GetLaborRate = "OMS/LabourMaster/GetLaborRate"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'FilterList', 
            'GetLaborRate'
        ].forEach(x => {
            (<any>LabourMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
